import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const GenericGuideSubTitle = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-sub-title' dangerouslySetInnerHTML={{ __html: props.iContent.subTitle?.value }}></div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideSubTitle);